<template>
  <div class="row clearfix">
    <div class="col-lg-4 col-md-6">
      <div class="widget calls-total kpi-card-accent">
        <div class="widget-body">
          <div class="d-flex justify-content-between align-items-center">
            <div class="state">
              <h6>Total Chamadas</h6>
              <h2>{{ callsTotal }}</h2>
            </div>
            <div class="icon">
              <i class="ik ik-phone-call" />
            </div>
          </div>
          <small class="text-small mt-10 d-block">Taxa de atendimento: {{ hitRate }}%</small>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6">
      <div class="widget answers-total kpi-card-accent">
        <div class="widget-body">
          <div class="d-flex justify-content-between align-items-center">
            <div class="state">
              <h6>Chamadas Atendidas</h6>
              <h2>{{ answersTotal }}</h2>
            </div>
            <div class="icon">
              <i class="ik ik-thumbs-up" />
            </div>
          </div>
          <small class="text-small mt-10 d-block">Tempo Falado: {{ durationsTotalTime }}</small>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6">
      <div class="widget extensions-total kpi-card-accent">
        <div class="widget-body">
          <div class="d-flex justify-content-between align-items-center">
            <div class="state">
              <h6>Total Ramais</h6>
              <h2>{{ extensionsTotal }}</h2>
            </div>
            <div class="icon">
              <i class="ik ik-users" />
            </div>
          </div>
          <small class="text-small mt-10 d-block">Tempo Médio de Atendimento: {{ tma }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardKpis',
  props: {
    callsTotal: { type: Number, default: 0 },
    hitRate: { type: Number, default: 0 },
    answersTotal: { type: Number, default: 0 },
    durationsTotalTime: { type: String, default: '' },
    extensionsTotal: { type: Number, default: 0 },
    tma: { type: String, default: '' }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/DashboardKpis.vue